// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".query-string-table-row[data-v-21ca7a24]{display:flex;align-items:center;border-bottom:1px solid #c8c8d4;padding:15px 0}.query-string-table-row__mark[data-v-21ca7a24]{width:13px;height:13px;box-sizing:border-box;border-radius:50%;flex-shrink:0}.query-string-table-row__mark--required[data-v-21ca7a24]{background:#ffa43c}.query-string-table-row__mark--unrequired[data-v-21ca7a24]{border:2px solid #2cc89d}", ""]);
// Exports
module.exports = exports;
